export default class BannerDownloadApp {
    constructor() {
        this.userAgent = navigator.userAgent;
        this.eventDelegation();
    }

    eventDelegation() {
        let bannerApp = document.querySelector('#banner-download-app');
        if (!bannerApp) return;

        let bannerAppCloseButton = bannerApp.querySelector('[data-action="close-banner-app"]');
        if (!bannerAppCloseButton) return;

        bannerAppCloseButton.addEventListener("click", () => {
            bannerApp.style.display = "none";
            let date = new Date;
            date.setMonth(date.getMonth() + 3);
            document.cookie = "hide_banner_app=true; expires=" + date;
        });

        const isAppleDevice = this.isAppleDevice();
        if (!this.canShowBanner(isAppleDevice)) {
            return;
        }
        this.showDeviceRating(bannerApp, isAppleDevice);
        this.checkDeviceBrowserToShowBanner(bannerApp, isAppleDevice)
    }

    checkDeviceBrowserToShowBanner(bannerApp, isAppleDevice) {
        let bannerAppAnchor = bannerApp.querySelector('[data-target="banner-app-anchor"]');
        let bannerAppButton = bannerApp.querySelector('[data-target="banner-app-button"]');
        let bannerLink = bannerAppAnchor.getAttribute((isAppleDevice) ? 'data-ios-link' : 'data-android-link');
        bannerAppAnchor.href = bannerLink;
        bannerAppButton.href = bannerLink;
        bannerApp.classList.remove('hidden');
    }

    showDeviceRating(bannerApp, isAppleDevice) {
        const deviceRating = bannerApp.querySelector('[data-target="banner-app-rating"]');
        if (!deviceRating) return;
        const rating = deviceRating.getAttribute((isAppleDevice) ? 'data-ios-rating' : 'data-android-rating');
        deviceRating.innerHTML = rating;

        this.showDeviceRatingStars(bannerApp, rating);
    }

    showDeviceRatingStars(bannerApp, rating) {
        const deviceRatingStars = bannerApp.querySelector('[data-entity="banner-rating-stars"]');
        if (!deviceRatingStars) return;
        const star = this.createRatingStar();
        let ratingStars = Math.trunc(rating);
        for (let i = 0; i < ratingStars; i++) {
            deviceRatingStars.appendChild(star.cloneNode(true));
        }
        const halfRatingStars = rating.toString().substring(2);
        if (halfRatingStars >= 3) {
            if (halfRatingStars < 7) {
                deviceRatingStars.appendChild(this.createRatingStar('half'));
            } else {
                deviceRatingStars.appendChild(this.createRatingStar('almost'));
            }
            ratingStars++;
        }

        for (let i = ratingStars; i < 5; i++) {
            deviceRatingStars.appendChild(this.createRatingStar('empty'));
        }
    }

    createRatingStar(starType = '') {
        const star = document.createElement('i');
        starType = 'ci-star' + (starType ? '-' + starType : '');
        star.classList.add('ci', starType, 'ci-s-12', 'color-category-light');
        return star;
    }

    isAppleDevice() {
        return /iPhone|iPad/.test(this.userAgent);
    }

    canShowBanner(isAppleDevice) {
        let isSafari = isAppleDevice && (/Safari/.test(this.userAgent)) && !(/Chrome|CriOS|FxiOS/.test(this.userAgent));
        return !(isSafari || document.cookie.indexOf('hide_banner_app') !== -1);
    }
}
